import {
  adaptRatingsDownload,
  adaptRatingsToStore,
  adaptSummaryToStore,
} from './adapters/ratingAdapter'

import { CONTENT_BACKOFFICE } from '@/services/axios.config'
import buildParamList from './utils/build_params'
import { buildServices } from './utils/build_services'

const services = [
  {
    name: 'listRatings',
    method: 'get',
    url: (params) => `/ratings${buildParamList(params)}`,
    resolver: adaptRatingsToStore,
  },
  {
    name: 'getCSVExport',
    method: 'get',
    url: (params) => `/ratings/export-csv${buildParamList(params)}`,
    resolver: adaptRatingsDownload,
  },
  {
    name: 'ratingSumary',
    method: 'get',
    url: (params) => `/ratings/summary${buildParamList(params)}`,
    resolver: adaptSummaryToStore,
  },
]

export const { listRatings, getCSVExport, ratingSumary } = buildServices(
  CONTENT_BACKOFFICE,
  services
)
